export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const arrayUnique = (array) => {
  return array.filter((value, index, self) => self.indexOf(value) === index);
};
